export const getActiveFieldsMock = {
    idProvider: 580,
    fiMerchantId: 2,
    modules: [
        {
            idModule: '5',
            label: 'Variants',
            campos: [],
            __typename: 'modules'
        },
        {
            idModule: '7',
            label: 'Prices',
            campos: [],
            __typename: 'modules'
        },
        {
            idModule: '8',
            label: 'Inventory',
            campos: [],
            __typename: 'modules'
        },
        {
            idModule: '9',
            label: 'Brand',
            campos: [],
            __typename: 'modules'
        },
        {
            idModule: '1',
            label: 'Product',
            campos: [
                {
                    idCampo: '3',
                    label: 'categoryName',
                    __typename: 'campos'
                },
                {
                    idCampo: '7',
                    label: 'tradePolicies',
                    __typename: 'campos'
                },
                {
                    idCampo: '10',
                    label: 'linkId',
                    __typename: 'campos'
                },
                {
                    idCampo: '11',
                    label: 'releaseDate',
                    __typename: 'campos'
                },
                {
                    idCampo: '13',
                    label: 'taxCode',
                    __typename: 'campos'
                },
                {
                    idCampo: '21',
                    label: 'isActive',
                    __typename: 'campos'
                },
                {
                    idCampo: '22',
                    label: 'isVisible',
                    __typename: 'campos'
                },
                {
                    idCampo: '23',
                    label: 'preventa',
                    __typename: 'campos'
                },
                {
                    idCampo: '24',
                    label: 'fechaInicioPreventa',
                    __typename: 'campos'
                },
                {
                    idCampo: '25',
                    label: 'fechaFinPreventa',
                    __typename: 'campos'
                },
                {
                    idCampo: '26',
                    label: 'isEcommerce',
                    __typename: 'campos'
                },
                {
                    idCampo: '27',
                    label: 'showWithoutStock',
                    __typename: 'campos'
                },
                {
                    idCampo: '43',
                    label: 'sobrePedido',
                    __typename: 'campos'
                },
                {
                    idCampo: '44',
                    label: 'lastDateUpdate',
                    __typename: 'campos'
                }
            ],
            __typename: 'modules'
        },
        {
            idModule: '2',
            label: 'Sku',
            campos: [
                {
                    idCampo: '21',
                    label: 'isActive',
                    __typename: 'campos'
                },
                {
                    idCampo: '30',
                    label: 'manufacturerCode',
                    __typename: 'campos'
                },
                {
                    idCampo: '32',
                    label: 'estimatedDateArrival',
                    __typename: 'campos'
                },
                {
                    idCampo: '45',
                    label: 'measurementUnit',
                    __typename: 'campos'
                },
                {
                    idCampo: '46',
                    label: 'unitMultiplier',
                    __typename: 'campos'
                },
                {
                    idCampo: '48',
                    label: 'creationDate',
                    __typename: 'campos'
                }
            ],
            __typename: 'modules'
        }
    ],
    campos: [
        {
            idCampo: '3',
            label: 'categoryName',
            __typename: 'campos'
        },
        {
            idCampo: '7',
            label: 'tradePolicies',
            __typename: 'campos'
        },
        {
            idCampo: '10',
            label: 'linkId',
            __typename: 'campos'
        },
        {
            idCampo: '11',
            label: 'releaseDate',
            __typename: 'campos'
        },
        {
            idCampo: '13',
            label: 'taxCode',
            __typename: 'campos'
        },
        {
            idCampo: '21',
            label: 'isActive',
            __typename: 'campos'
        },
        {
            idCampo: '22',
            label: 'isVisible',
            __typename: 'campos'
        },
        {
            idCampo: '23',
            label: 'preventa',
            __typename: 'campos'
        },
        {
            idCampo: '24',
            label: 'fechaInicioPreventa',
            __typename: 'campos'
        },
        {
            idCampo: '25',
            label: 'fechaFinPreventa',
            __typename: 'campos'
        },
        {
            idCampo: '26',
            label: 'isEcommerce',
            __typename: 'campos'
        },
        {
            idCampo: '27',
            label: 'showWithoutStock',
            __typename: 'campos'
        },
        {
            idCampo: '43',
            label: 'sobrePedido',
            __typename: 'campos'
        },
        {
            idCampo: '44',
            label: 'lastDateUpdate',
            __typename: 'campos'
        },
        {
            idCampo: '21',
            label: 'isActive',
            __typename: 'campos'
        },
        {
            idCampo: '30',
            label: 'manufacturerCode',
            __typename: 'campos'
        },
        {
            idCampo: '32',
            label: 'estimatedDateArrival',
            __typename: 'campos'
        },
        {
            idCampo: '45',
            label: 'measurementUnit',
            __typename: 'campos'
        },
        {
            idCampo: '46',
            label: 'unitMultiplier',
            __typename: 'campos'
        },
        {
            idCampo: '48',
            label: 'creationDate',
            __typename: 'campos'
        }
    ],
    __typename: 'providerFields'
};
